var next = __webpack_require__.x;
__webpack_require__.x = function() {
	return Promise.all([6485,2437,1133].map(__webpack_require__.e, __webpack_require__)).then(next);
};